import { render, staticRenderFns } from "./ComponentImportStudy.vue?vue&type=template&id=aeac14c4&"
import script from "./ComponentImportStudy.vue?vue&type=script&lang=js&"
export * from "./ComponentImportStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports